import React from "react";

function MainTitle() {
  return (
    <div className="main-title m-b-20 text-center">
      {/* <h3>MIIP Gala Dinner & Awards Night</h3>
      <h3>2024</h3> */}
      <h3>MIIP 15th Anniversary Dinner</h3>
      <h3>2025</h3>
    </div>
  );
}

export default MainTitle;
